import { postApi } from '../components/Utility'
import {
    action,
    makeObservable,
    observable
} from 'mobx';

import { encode as base64_encode } from "base-64";
import config from "../config";

class SchoolDashboardStore {
    loading = false;
    studentStatusCount = [];
    vehicleCount = []
    studentListData = []
    studentsData = []
    pieChartData = []
    alertsData = []
    tripDetails = []
    rootStore

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            studentStatusCount: observable,
            vehicleCount: observable,
            studentListData: observable,
            studentsData: observable,
            pieChartData: observable,
            alertsData: observable,
            tripDetails: observable,
            getDashboardCount: action,
            getDashboardListData: action,
            getDashboardData: action,
            getPieChartData: action,
            getAlertsData: action,
            getTripData: action
        });
        this.rootStore = rootStore;

    }



    async getDashboardCount(companyId) {
        this.loading = true;
        var postData = {
            companyId: companyId,
        };
        var response = await postApi
            .getClient()
            // .get("http://localhost:3048" + "/passenger/studentsDashboardCount", {
            .get(config.NodeUrl + "/passenger/studentsDashboardCount", {
                params: postData,
            });

        this.studentStatusCount = response?.data?.data?.studentsCount
        this.vehicleCount = response?.data?.data?.vehicleCount?.vehicleCount
        this.tripsCount = response?.data?.data?.totalTripsCount
        this.loading = false;

        return response?.data
    }


    async getDashboardListData({ companyId, statusType }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            statusType: statusType
        };
        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/passenger/studentDashboardListData", {
                params: postData,
            });
        this.studentListData = response?.data?.data
        this.loading = false;
        return response?.data?.data
    }

    async getDashboardData(companyId) {
        this.loading = true;
        var postData = {
            companyId: companyId,
        };

        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/passenger/studentDashboardMainGridData", {
                params: postData,
            });
        this.studentsData = response?.data?.data
        this.loading = false;
        return response?.data?.data
    }

    async getPieChartData({ companyId, dailyStatus, selectedDate }) {
        this.loading = true;
        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/passenger/studentDashboardPieChartData", {
                params: {
                    companyId: companyId,
                    dailyStatus: dailyStatus,
                    selectedDate: selectedDate
                }
            });

        const data = response?.data?.data;
        if (data) {
            const onboard = Number(data?.onboardPercent) || 0;
            const offboard = Number(data?.offboardPercent) || 0;
            const absent = Number(data?.absentPercent) || 0;

            const total = onboard + offboard + absent;

            if (total === 0) {
                this.pieChartData = [];
                this.noData = true;
            } else {
                this.pieChartData = [
                    { name: "Onboard", value: onboard },
                    { name: "Offboard", value: offboard },
                    { name: "Absent", value: absent }
                ];
                this.noData = false;
            }
            this.loading = false;
            return response?.data?.data
        }

    }

    async getMaxSpeedData({ companyId, isadmin, offset, limit, currentDate }) {

        var postData =
            { "companyId": companyId, "type": "maxspeed", "isadmin": isadmin, "offset": 0, "limit": 50 }

        var base64Input = await base64_encode(JSON.stringify(postData));
        this.loading = true;

        var response = await postApi
            .getClient()
            .post(
                "index.php?c=fleetDashboard&a=maxSpeedGraph",
                "postData=" + base64Input
            );

        if (response?.data?.data?.MaxSpeedGraph) {
            this.maxSpeedData = response?.data?.data?.MaxSpeedGraph.map((val) => {
                return {
                    maxSpeed: Number(val.maxSpeed),
                    vehicleId: val.vehicleId,
                    vehicleNo: val.vehicleNo
                }
            })
        }

        this.loading = false;

    }


    async getAlertsData(companyId) {
        this.loading = true;
        var postData = {
            companyId: companyId,
        };
        var response = await postApi
            .getClient()
            .get(config.NodeUrl + "/passenger/showRecentAlerts", {
                params: postData,
            });
        this.alertsData = response?.data?.data
        this.loading = false;
        return response?.data?.data
    }
    async getTripData({ companyId, statusType }) {
        this.loading = true;
        var postData = {
            companyId, statusType
        };
        var response = await postApi
            .getClient()
            // .get("http://localhost:3048" + "/passenger/getTripDetails", {
            .get(config.NodeUrl + "/passenger/getTripDetails", {
                params: postData,
            });
        console.log(response.data?.data);
        this.tripDetails = response?.data?.data
        this.loading = false;
        return response?.data?.data
    }

}

export default SchoolDashboardStore;
